import React from 'react'
import { Stack, TextInput } from '@mantine/core'

interface LocationNameStepProps {
  locationName: string | null | undefined
  updateLocationName: (locationName: string) => void
}

const LocationNameStep = ({
  locationName,
  updateLocationName,
}: LocationNameStepProps) => {
  return (
    <Stack align='center' pb='lg' ml='sm' mr='sm' w='100%'>
      <TextInput
        w='100%'
        maw={400}
        placeholder='Downtown Store'
        maxLength={50}
        value={locationName ?? ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          updateLocationName(e.target.value)
        }
      />
    </Stack>
  )
}

export default LocationNameStep
